import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-add2",
  "use": "icon-add2-usage",
  "viewBox": "0 0 65 65",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 65 65\" id=\"icon-add2\"><path d=\"M32.082.533c-17.672 0-32 14.328-32 32s14.328 32 32 32 32-14.328 32-32-14.328-32-32-32zm16 34.667H34.75v13.333a2.666 2.666 0 1 1-5.334 0V35.2H16.082a2.666 2.666 0 1 1 0-5.333h13.333V16.533a2.666 2.666 0 1 1 5.334 0v13.334h13.333a2.666 2.666 0 1 1 0 5.333z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol